var $ = jQuery.noConflict();

$(document).ready(function() {
    $('.vimeo-button').on('click', function() {
        var playerId = $(this).closest('.video-wrap').find('.vimeo-video').attr('id');

        
        var player = document.getElementById(playerId);
        var data = { method: "play" };
        player.contentWindow.postMessage(JSON.stringify(data), "*");

        // Oculta el contenedor completo '.video-info'
        $(this).closest('.video-info').hide();

        $(this).closest('.video-wrap').addClass('interacted');
        $(this).closest('.video-wrap').removeClass('loading');
    });
});

// Get the button element with the class 'video-wrap__play'
var playButton = document.querySelector(".video-wrap__play");

// Get the div element with the class 'video-block__text'
var textBlock = document.querySelector(".video-block__text");

// Check if playButton and textBlock exist
if (playButton && textBlock) {
    // Add a click event listener to the button
    playButton.addEventListener("click", function() {
        // Add the class 'd-none' to hide the text block
        textBlock.classList.add("d-none");
    });
}